import { ActionType, createReducer } from 'typesafe-actions';
import { changeCommissionModeAction, setCommissionModeAction } from './actions';
import { ICommissionModeState } from './types';

export const commissionModeState: ICommissionModeState = {
  isCommissionMode: true,
};

const actions = {
  changeCommissionModeAction,
  setCommissionModeAction,
};

export const commissionModeReducer = createReducer<
  ICommissionModeState,
  ActionType<typeof actions>
>(commissionModeState)
  .handleAction(changeCommissionModeAction, (state) => ({
    ...state,
    isCommissionMode: !state.isCommissionMode,
  }))
  .handleAction(setCommissionModeAction, (state, { payload }) => ({
    ...state,
    isCommissionMode: payload,
  }));
